const routes = [
    {path: "/", redirect: "mainPage"},
    {
        path: "/",
        name: "layout",
        component: () => import(/* webpackChunkName: "Home" */ '@/components/layout/index.vue'),
        children:[
            {
                path: "/mainPage",
                name: "mainPage",
                meta:{
                    activeNav:'mainPage'
                },
                component:() => import(/* webpackChunkName: "mainPage" */ '../views/mainPage/mainPage.vue')
            },
            {
                path: "/serviceArea",
                name: "serviceArea",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "serviceArea" */ '../views/serviceArea/serviceArea.vue'),
            },
            {
                path: "/farmChemicalRegister",
                name: "farmChemicalRegister",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "farmChemicalRegister" */ '../views/serviceArea/farmChemicalRegister.vue'),
            },
            {
                path: "/farmChemicalRiskEstimate",
                name: "farmChemicalRiskEstimate",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "farmChemicalRiskEstimate" */ '../views/serviceArea/farmChemicalRiskEstimate.vue'),
            },
            {
                path: "/industryChemical12",
                name: "industryChemical12",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "industryChemical12" */ '../views/serviceArea/industryChemical12.vue'),
            },
            {
                path: "/industryChemicalRiskRegister",
                name: "industryChemicalRiskRegister",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "industryChemicalRiskRegister" */ '../views/serviceArea/industryChemicalRiskRegister.vue'),
            },
            {
                path: "/healthFoods",
                name: "healthFoods",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "healthFoods" */ '../views/serviceArea/healthFoods.vue'),
            },
            {
                path: "/newFoodsRegister",
                name: "newFoodsRegister",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "newFoodsRegister" */ '../views/serviceArea/newFoodsRegister.vue'),
            },
            {
                path: "/medicalFoods",
                name: "medicalFoods",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "medicalFoods" */ '../views/serviceArea/medicalFoods.vue'),
            },
            {
                path: "/makeupNewMaterial",
                name: "makeupNewMaterial",
                meta:{
                    activeNav:'serviceArea'
                },
                component:() => import(/* webpackChunkName: "makeupNewMaterial" */ '../views/serviceArea/makeupNewMaterial.vue'),
            },
            {
                path: "/aboutRs",
                name: "aboutRs",
                meta:{
                    activeNav:'aboutRs'
                },
                component:() => import(/* webpackChunkName: "aboutRs" */ '../views/aboutRs/aboutRs.vue'),
            },
            {
                path: "/contactUs",
                name: "contactUs",
                meta:{
                    activeNav:'contactUs'
                },
                component:() => import(/* webpackChunkName: "contactUs" */ '../views/contactUs/contactUs.vue'),
            },
            {
                path: "/joinRs",
                name: "joinRs",
                meta:{
                    activeNav:'joinRs'
                },
                component:() => import(/* webpackChunkName: "joinRs" */ '../views/joinRs/joinRs.vue'),
            },
        ]
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "mainPage"
    },
]

export default routes
